/* eslint-disable class-methods-use-this */
import { Easing } from '@tweenjs/tween.js';
import {
  createCubicBezierEasing,
  generateExponential,
  smoothSequenceEasingWithCutoffValue
} from 'rf-ui/GameRenderer/customEasing';
import SpinProvider from './SpinProvider';
import type { RandomSpin } from './types';

export default class FunSpinProvider extends SpinProvider {
  getRandomSpin(roundsLeft: number, counterClockwiseChance: number, isBehind: boolean): RandomSpin {
    if (roundsLeft <= 1) {
      if (Math.random() < 0.1) {
        const bez = createCubicBezierEasing(0, 0.75, 0.72, 0.97);
        return {
          time: 44_000,
          clockwise: false,
          easing: smoothSequenceEasingWithCutoffValue(bez, generateExponential(300).Out, 0.5, 0.5, 0),
          ticker: true,
          hand: 're-roll',
          wholeRounds: 10
        };
      }
      return {
        time: 22_000,
        clockWise: false,
        easing: generateExponential(300).Out,
        ticker: true,
        hand: false,
        wholeRounds: 5
      };
    }

    const clockWise = SpinProvider.counterClockwise(counterClockwiseChance);

    if (roundsLeft <= 3) {
      return {
        time: 12_000,
        clockWise,
        easing: generateExponential(300).Out,
        ticker: true,
        hand: false
      };
    }

    // Hand
    if (Math.random() < 0.05) {
      if (Math.random() < 0.7) {
        return {
          time: 5_000,
          clockWise,
          easing: smoothSequenceEasingWithCutoffValue(Easing.Linear.InOut, Easing.Quadratic.Out, 0.9, 0.95, 0.05),
          ticker: true,
          hand: 'real'
        };
      }
      return {
        time: 7_000,
        clockWise,
        easing: generateExponential(300).Out,
        ticker: true,
        hand: 'fake'
      };
    }

    if (isBehind) {
      return {
        time: 3_000,
        clockWise,
        easing: generateExponential(300).Out,
        ticker: true,
        hand: false
      };
    }

    const random = Math.random();
    if (random > 0.4) {
      return {
        time: 5_000,
        clockWise,
        easing: generateExponential(300).Out,
        ticker: true,
        hand: false
      };
    }
    if (random > 0.2) {
      return {
        time: 3_000,
        clockWise,
        easing: generateExponential(300).Out,
        ticker: true,
        hand: false
      };
    }
    return {
      time: 7_000,
      clockWise,
      easing: generateExponential(300).Out,
      ticker: true,
      hand: false
    };
  }
}
